import React, { useState } from "react";
import { MdDelete } from "react-icons/md";

function AddItems({ form, errors, touched, getinput, setGetinput }) {
  const [input, setInput] = useState("");
  // const [getinput, setGetinput] = useState([]);

  function Add() {
    setGetinput([
      ...getinput,
      {
        items: input[0],
        category: input[1],
        rate: input[2],
        quantity: input[3],
      },
    ]);
  }
  const Delete = (id) => {
    let removeData = getinput;
    removeData.splice(id, 1);
    setGetinput([...removeData]);
  };

  return (
    <div>
      <div className="grid grid-cols-9   gap-8 py-10">
        {form.map((val, i) => {
          if (val.type === "text") {
            return (
              <div key={i} className="col-span-1">
                <label>{val.label}</label>
                <input
                  className="focus:outline-none  border-2 rounded-lg border-gray-500 px-3 py-2 w-full"
                  type={val.type}
                  name={val.name}
                  onChange={(e) => {
                    let arr = [...input];
                    arr[i] = e.target.value;
                    setInput(arr);
                  }}
                />
                {/* <div
                  className={`${
                    errors[val.apiKey] && touched[val.apiKey]
                      ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                      : ""
                  }`}
                >
                  {errors[val.apiKey] && touched[val.apiKey]
                    ? errors[val.apiKey]
                    : ""}
                </div> */}
              </div>
            );
          } else {
            return (
              <div key={i} className="col-span-3 ">
                <label>{val.label}</label>
                <select
                  className="focus:outline-none  border-2 rounded-lg border-gray-500 px-3 py-2 w-full"
                  name={val.name}
                  onChange={(e) => {
                    let arr = [...input];
                    arr[i] = e.target.value;
                    setInput(arr);
                  }}
                >
                  <option name={val.name} value="">
                    Select {val.label}
                  </option>
                  {val.options.map((option, i) => (
                    <option key={i} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                {/* <div
                  className={`${
                    errors[val.apiKey] && touched[val.apiKey]
                      ? " bg-red-50 w-full p-1 my-1 text-red-500 text-sm"
                      : ""
                  }`}
                >
                  {errors[val.apiKey] && touched[val.apiKey]
                    ? errors[val.apiKey]
                    : ""}
                </div> */}
              </div>
            );
          }
        })}

        <div className="col-span-1 flex items-center">
          <p
            className="px-6 py-2 rounded-sm bg-yellow-600 text-white mt-6 cursor-pointer"
            onClick={() => Add()}
          >
            Add
          </p>
        </div>
      </div>
      <div className="Table">
        <table className="w-full rounded-lg bg-main">
          <thead className="w-full    rounded-t-xl  ">
            <tr className="grid grid-cols-6 py-3 rounded-t-xl place-content-center place-items-center ">
              <th className="text-white text-lg font-medium ">Sn</th>
              <th className="text-white text-lg font-medium ">Items</th>
              <th className="text-white text-lg font-medium ">Category</th>
              <th className="text-white text-lg font-medium ">Rate</th>
              <th className="text-white text-lg font-medium ">Qty</th>
            </tr>
          </thead>

          <tbody className="w-full flex flex-col  ">
            {getinput.map((val, i) => {
              return (
                <tr
                  key={i}
                  className={`grid grid-cols-6 py-3 border-gray-50 bg-white  place-content-center place-items-center `}
                >
                  <td className="font-medium  text-md">{i + 1}</td>
                  <td className="font-medium text-md">{val.items}</td>
                  <td className="font-medium text-md">{val.category}</td>
                  <td className="font-medium text-md">{val.rate}</td>
                  <td className="font-medium text-md">{val.quantity}</td>
                  <td className="flex text-sm gap-5 cursor-pointer">
                    <p className="text-green-600"> Edit</p>
                    <p
                      className="text-red-500 hover:text-red-600 "
                      onClick={() => Delete(i)}
                    >
                      <MdDelete />{" "}
                    </p>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AddItems;
